<template>
	<div>
		<vs-row vs-type="flex" vs-justify="space-between" class="mb-2" v-if="isGestor">                  
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">  
            <vs-card>
                <vue-apex-charts type=bar height="200" :options="graficoDespesasDo12UltimosMes.chartOptions" :series="graficoDespesasDo12UltimosMes.series" />		
            </vs-card>
          </vs-col>
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="6" style="padding-right: 10px;">  
				<vx-card cardBackground="#ffeb3b"  v-if="qtdPedidosCompraPendente" @click="irParaPedidosCompras()" style="margim-right: 10px; height: 235px;">
					<h6> Pedidos de compras a aprovar: {{qtdPedidosCompraPendente}}. </h6> <p class="mt-2">Clique para visualizar</p>
				</vx-card>
          </vs-col>
		</vs-row>
		<vx-card class="-mt-4">
			<div class="flex w-full items-center">
				<h6> Faturas a vencer nos próximos 7 dias e vencidas [ {{listaFaturas.length}} ] </h6>
				<div class="flex ml-4">
					<vs-button size="small" class="nowrap" icon="search" color="primary" @click="fetchLista" ></vs-button>             
					<vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="routeNovoRegistro"></vs-button>             
				</div>
			</div>

			<vs-table :data="listaFaturas" noDataText="Nenhum fatura." stripe v-model="itemContaSelecionada" @selected="onRowSelectedRegistro" class="tabelaComScroll">
				<template slot="thead">
					<vs-th></vs-th>
					<vs-th><small>Número</small></vs-th>  
					<vs-th><small>Unidade</small></vs-th>                                
					<vs-th><small>Vencimento</small></vs-th>                              
					<vs-th><small>Valor</small></vs-th>                              
					<vs-th><small>Fornecedor</small></vs-th>
					<vs-th><small>Plano de Conta</small></vs-th>
					<vs-th><small>Complemento</small></vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="tr.isVencida ?'danger':null">
						<vs-td :data="indextr">
							<small>{{ (indextr + 1)}}</small>
						</vs-td>
						<vs-td :data="tr.numeroConta"><small> {{ tr.numeroConta }} </small></vs-td>					
						<vs-td :data="tr.unidadeOperacional.nome"><small> {{ tr.unidadeOperacional.nome }} </small></vs-td>
						<vs-td :data="tr.vencimentoFormatado"><small>  {{ tr.vencimentoFormatado }} </small></vs-td>
						<vs-td :data="tr.valor"><small> {{ formatarMoedaReal(tr.valor) }} </small></vs-td>
						<vs-td :data="tr.favorecido.nome"><small> {{ tr.favorecido.nome }} </small></vs-td>
						<vs-td :data="tr.contaPlanoConta.nome"><small > {{ tr.contaPlanoConta.nome }} </small></vs-td>
						<vs-td :data="tr.complemento"><small> {{ tr.complemento }} </small></vs-td>                    
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
		
	</div>
</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import VueApexCharts from 'vue-apexcharts'

export default {
	components: {
        VueApexCharts        
    },
	data() {
		return {
			itemContaSelecionada: null,
			listaFaturas: [],
			qtdPedidosCompraPendente: 0,
			resultadoDespesa: [],
			resultadoReceita: [],
			resultadoLucro: [],
			graficoDespesasDo12UltimosMes: {
               series: [{ name: 'Despesa', data: this.resultadoDespesa }, { name: 'Receita', data: this.resultadoReceita }, { name: 'Lucro', data: this.resultadoLucro } ],
              chartOptions: {
                  colors: ['#de5f4c', '#52a1a8', '#e0c641'],
                  grid: {
                      borderColor: '#ebebeb',
                      padding: {
                          left: 0,
                          right: 0
                      }
                  },
                  legend: {
                      show: false,
                  },
                  dataLabels: {
                      enabled: true,                        
                      offsetY: -15,
                      style: {
                        fontSize: '12px',
                        colors: ["#000000", "#000000", "#000000"]
                      },                      
                      formatter: function (y) {
                        return "R$ " + generico.formatarNumero(y);
                      },
                      hideOverflowingLabels: false
                  },
                  chart: {
                      id: 'grafico12Meses',                      
                      type: 'bar',
                      toolbar: { show: true },                      
                  },                  
                  plotOptions: {
                      bar: {                          
                          columnWidth: '80%',
                          dataLabels: {      
                            position: 'top',  
                            hideOverflowingLabels: false,                            
                          }
                      },
                      dataLabels: {
                        enabled: true,                        
                        style: {
                            colors: ['#333']
                        },
                        offsetX: 30
                      },
                  },
                  xaxis: {
                      labels: {
                          style: {
                              cssClass: 'text-grey fill-current',
                          }
                      },
                      axisTicks: {
                          show: false,
                      },
                      categories: ['RESULTADO'],
                      axisBorder: {
                          show: true,
                      },
                  },
                  yaxis: {
                      tickAmount: 5,
                      labels: {
                          style: {
                              cssClass: 'text-grey fill-current',
                          },                          
                          formatter: function (y) {
                            return generico.formatarNumero(y);
                          }
                      },
                  },
                  tooltip: {
                      x: { show: false },
                      y: {
                        formatter: function (val) {
                          return generico.formatarMoedaReal(val)
                        }
                      }
                  },
              }
          },
		}
	},
	mounted() {
		this.fetchLista();
		this.fetchQtdPedidoCompŕas();
		this.graficoDespesasDo12UltimosMes.series = [{ name: 'Despesa', data: this.resultadoDespesa }, { name: 'Receita', data: this.resultadoReceita }, { name: 'Lucro', data: this.resultadoLucro } ];
		this.fetchValorTotalDespesas();
		this.fetchValorTotalReceita();
		this.fetchValorTotalLucro();
	},
	computed: {
		isGestor() {
			return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
		}
	},
	methods:{
		irParaPedidosCompras(){
			this.$router.push({
				name: 'financeiro-compras-pesquisar' ,
				params: {
					filtroInicial: { dataCompraInicio:  null, dataCompraFim : null, status: 'SOLICITADA', nomeFavorecido: null }
				}
			});
		},
		fetchValorTotalLucro() {    			
			var date = new Date();
			const params = new URLSearchParams();			
			params.append("mes", date.getMonth()+1);			

			axios.post("/Lancamento/ListarLucro", params, {              
					credentials: 'include',
					responseEncoding: 'iso88591',
					withCredentials: true } )
			.then((response) => {
				this.$vs.loading.close();
				if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
					this.$router.push({ path: '/' });
				} else {
					this.resultadoLucro.push(parseFloat(response.data.Resultado.lista[0].valor));		
					this.graficoDespesasDo12UltimosMes.series = [{ name: 'Despesa', data: this.resultadoDespesa }, { name: 'Receita', data: this.resultadoReceita }, { name: 'Lucro', data: this.resultadoLucro } ];					
				}
			})
			.catch((error) => { 				
				/* eslint-disable no-console */ console.log("Erro fetchValorTotalLucro - " + error); 
			})  				
		},
		fetchValorTotalReceita() {    			
			var date = new Date();
			const params = new URLSearchParams();			
			params.append("mes", date.getMonth()+1);			

			axios.post("/Lancamento/ListarReceitasMesCorrente", params, {              
					credentials: 'include',
					responseEncoding: 'iso88591',
					withCredentials: true } )
			.then((response) => {
				this.$vs.loading.close();
				if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
					this.$router.push({ path: '/' });
				} else {
					this.$set(this.resultadoReceita, 0, parseFloat(response.data.Resultado.lista[0].valor));											
				}
			})
			.catch((error) => { 				
				/* eslint-disable no-console */ console.log("Erro fetchValorTotalReceita - " + error); 
			})  				
		},
		fetchValorTotalDespesas() {    			
			var date = new Date();
			const params = new URLSearchParams();			
			params.append("mes", date.getMonth()+1);			

			axios.post("/Lancamento/ListarDespesasMesCorrente", params, {              
					credentials: 'include',
					responseEncoding: 'iso88591',
					withCredentials: true } )
			.then((response) => {
				this.$vs.loading.close();
				if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
					this.$router.push({ path: '/' });
				} else {					
					this.$set(this.resultadoDespesa, 0, parseFloat(response.data.Resultado.lista[0].valor));											
				}
			})
			.catch((error) => { 				
				/* eslint-disable no-console */ console.log("Erro fetchValorTotalDespesas - " + error); 
			})  				
		},
		fetchQtdPedidoCompŕas() {    
			
			const params = new URLSearchParams();
			params.append('pagina', -1);
			params.append("status", 'SOLICITADA');			

			axios.post("/Compra/Listar", params, {              
					credentials: 'include',
					responseEncoding: 'iso88591',
					withCredentials: true } )
			.then((response) => {
				this.$vs.loading.close();
				if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
					this.$router.push({ path: '/' });
				} else {
					this.qtdPedidosCompraPendente = response.data.Resultado.quantidade;
					
				}
			})
			.catch((error) => { 
				this.$vs.loading.close();
				/* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
			})    
								
		},
		formatarMoedaReal(valor) {
			return generico.formatarMoedaReal(valor);
		},
		fetchLista() {     
			this.$vs.loading() 
			
			axios.get("/Conta/ListarContaDashboard", null, {              
					credentials: 'include',
					responseEncoding: 'iso88591',
					withCredentials: true } )
			.then((response) => {
				this.$vs.loading.close();
				if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
					this.$router.push({ path: '/' });
				} else {										
					this.listaFaturas = response.data.Resultado.lista;
				}
			})
			.catch((error) => { 
				this.$vs.loading.close();
				/* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
			})    
								
		},
		onRowSelectedRegistro() {						
			this.$router.push({
					name: "financeiro-contas-a-pagar-editar",
					params: {
						registroOriginal: this.itemContaSelecionada
					}
			})

		},
		routeNovoRegistro() {
		let self_ = this;

			self_.$router.push({
					name: "financeiro-contas-a-pagar-editar"                     
			})
		},
	}
}

</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      max-height: calc(35vh);
      position: relative;      
    } 
</style>
